import requester from '@/lib/axios';
import { TrueOrFalseActivityElement } from '@/models/_deprecated/ActivityElement';

/** @deprecated Use getTrueOrFalseQuestion from @/data/services/question/trueOrFalseQuestionServices */
export const getTrueOrFalseActivity = async (questionId: number) => {
  const { data: trueOrFalseActivity } =
    await requester().get<TrueOrFalseActivityElement>(
      `true-or-false-activity/${questionId}/`,
    );
  return trueOrFalseActivity;
};

/** @deprecated Use createTrueOrFalseQuestion from @/data/services/question/trueOrFalseQuestionServices */
export const createTrueOrFalseActivity = async (
  body: Partial<TrueOrFalseActivityElement>,
) => {
  const { data: trueOrFalseActivity } =
    await requester().post<TrueOrFalseActivityElement>(
      `true-or-false-activity/`,
      body,
    );
  return trueOrFalseActivity;
};

/** @deprecated Use deleteTrueOrFalseQuestion from @/data/services/question/trueOrFalseQuestionServices */
export const deleteTrueOrFalseActivity = async (questionId: number) => {
  await requester().delete<TrueOrFalseActivityElement>(
    `true-or-false-activity/${questionId}/`,
  );
};
